import styles from "./index.module.css";
import * as gtag from "lib/gtag";
import { MdClose } from "react-icons/md";

export const ToastCloseButton = ({ closeToast }: any) => (
  <button
    className={styles.Button}
    type="button"
    onClick={(e) => {
      gtag.event({ action: "dismiss_toast", label: "Toast" });
      closeToast(e);
    }}
  >
    <MdClose size={16} />
  </button>
);
